import type { StateCreator } from 'zustand'

import type { GatewaysDataSlice, GatewaysStore } from '../types'

export const createGatewaysDataSlice: StateCreator<
  GatewaysStore,
  [['zustand/immer', never]],
  [],
  GatewaysDataSlice
> = () => ({
  gateways: [],
  loading: false,
  error: null,
  lastFetchedProjectId: null,
})
